import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

const BORDER_COLOR = "#000";
const BORDER_WIDTH = 1;

const styles = StyleSheet.create({
  page: {
    padding: 20,
    paddingBottom: 50, // 🔥 Reservamos espacio para el footer
    fontSize: 10,
    fontFamily: "Helvetica",
  },
  banner: {
    width: "100%",
    height: 80,
    marginBottom: 10,
  },
  title: {
    fontSize: 10,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 10,
  },
  table: {
    display: "flex",
    flexDirection: "column",
    borderWidth: BORDER_WIDTH,
    borderColor: BORDER_COLOR,
    borderStyle: "solid",
    marginTop: 10,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCell: {
    borderRightWidth: BORDER_WIDTH,
    borderBottomWidth: BORDER_WIDTH,
    borderColor: BORDER_COLOR,
    borderStyle: "solid",
    padding: 4,
  },
  // Para la última celda de la fila quitamos el borde derecho
  lastCell: {
    borderRightWidth: 0,
  },
  // Para la última fila quitamos el borde inferior en celdas
  lastRow: {
    borderBottomWidth: 0,
  },
  signatureLine: {
    borderBottomWidth: BORDER_WIDTH,
    borderColor: BORDER_COLOR,
    height: 40,
    marginTop: 10,
  },
  tableRowColored: {
    backgroundColor: "#bbb",
    borderWidth: 1,
    borderColor: "#999",
    borderStyle: "solid",
  },

  centeredText: {
    textAlign: "center",
  },
  underlined: {
    fontSize: 10,
    textAlign: "justify",
    marginBottom: 5,
    fontWeight: "normal", // Sin negrita
    borderBottomColor: "#000",
    textDecoration: "underline", // Subraya el texto
    fontWeight: "normal !important", // Asegura que no tenga negrita
  },
  boldText: {
    fontSize: 10,
    fontFamily: "Helvetica-Bold", // más negrita real
  },

 content: {
  flexGrow: 1,
},

footerCodeContainer: {
  position: 'absolute',
  bottom: 30, // Distancia desde el borde inferior
  left: 30,
  right: 30,
  textAlign: 'left',
},

footerCode: {
  fontSize: 10,
  fontFamily: "Helvetica",
   color: "black",
     letterSpacing: 1.5,

},
  centeredText: {
    textAlign: "center",
  },
  defaultHeightRow: {
    height: 50, // altura por defecto cuando no haya contenido
  },

  textoNotas: {
    fontSize: 8,
    textAlign: "justify",
    marginBottom: 5,
    fontWeight: "normal", // Sin negrita
    borderBottomColor: "#000",
    textDecoration: "underline", // Subraya el texto
    fontWeight: "normal !important", // Asegura que no tenga negrita
    fontFamily: "Helvetica-Bold", // más negrita real
    fontStyle: "italic", // para que el texto quede inclinado (cursiva)
    textAlign: "center",
  },
});

// Componente para renderizar celdas con flex y estilos
const TableCell = ({ children, flex, isLastCell }) => (
  <View style={[styles.tableCell, { flex }, isLastCell && styles.lastCell]}>
    <Text>{children}</Text>
  </View>
);

const PdfDocumentoAceptacion = ({ data }) => (
  <Document>
    <Page size="A4" style={styles.page}>
        {/* Contenido principal */}

      <View style={styles.content}>
      <View fixed>
        <Image src={"Banner_membrete.png"} style={styles.banner} />
      </View>

      <View style={styles.table}>
        {/* Fila 1: 1 columnas */}
        <View style={[styles.tableRow, styles.tableRowColored, { height: 35 }]}>
          <TableCell flex={1} isLastCell>
            <Text style={[styles.title, styles.centeredText]}>
              FORMATO DE ACEPTACIÓN DE PLAN DE COMPRAS PROYECTOS PRODUCTIVOS
              FORTALECIMIENTO DE LA REINCORPORACIÓN ECONÓMICA Y SOCIAL
            </Text>
          </TableCell>
        </View>

        <View style={styles.tableRow}>
          <TableCell style={styles.boldText} flex={2}>
            <Text style={styles.boldText}>Título del proyecto</Text>
          </TableCell>
          <TableCell flex={3}>{data?.titulo_proyecto || ""}</TableCell>

          <TableCell style={styles.boldText} flex={2}>
            <Text style={styles.boldText}>Linea productiva</Text>
          </TableCell>
          <TableCell flex={2}>{data?.linea_productiva || ""}</TableCell>

          <TableCell style={styles.boldText} flex={1}>
            <Text style={styles.boldText}>CODA</Text>
          </TableCell>
          <TableCell flex={1} isLastCell>
            {data?.codigo_sirr || ""}
          </TableCell>
        </View>

        <View style={styles.tableRow}>
          <TableCell style={styles.boldText} flex={2}>
            <Text style={styles.boldText}>Objetivo principal del proyecto</Text>
          </TableCell>
          <TableCell flex={9.8} isLastCell>
            {data?.objetivo_proyecto || ""}
          </TableCell>
        </View>

        <View style={styles.tableRow}>
          <TableCell style={styles.boldText} flex={4}>
            <Text style={styles.boldText}>
              Nombre completo del titular del proyecto
            </Text>
          </TableCell>
          <TableCell flex={3}>{data?.nombre_titular || ""}</TableCell>

          <TableCell style={styles.boldText} flex={1}>
            <Text style={styles.boldText}>Cédula</Text>
          </TableCell>
          <TableCell isLastCell flex={2}>
            {data?.numero_cedula || ""}
          </TableCell>
        </View>

        {Array.isArray(data.lista_participantes) &&
          data.lista_participantes.length > 0 &&
          (() => {
            const totalParticipantes = data.lista_participantes.length;
            return (
              <View style={styles.tableRow}>
                <TableCell style={styles.boldText} flex={1.8}>
                  <Text style={styles.boldText}>Individual</Text>
                </TableCell>
                <TableCell flex={1}>
                  <Text style={styles.text}>
                    {totalParticipantes === 1 ? "x" : ""}
                  </Text>
                </TableCell>

                <TableCell style={styles.boldText} flex={3}>
                  <Text style={styles.boldText}>Individual Asociativo</Text>
                </TableCell>
                <TableCell flex={1}>
                  <Text style={styles.text}>
                    {totalParticipantes > 1 ? "x" : ""}
                  </Text>
                </TableCell>

                <TableCell style={styles.boldText} flex={1}>
                  <Text style={styles.boldText}>PRE PP</Text>
                </TableCell>
                <TableCell flex={2.05} isLastCell>
                  {data?.codigo_pre || ""}
                </TableCell>
              </View>
            );
          })()}

        <View style={styles.tableRow}>
          <TableCell style={styles.boldText} flex={2.25}>
            <Text style={styles.boldText}>Grupo territorial</Text>
          </TableCell>
          <TableCell flex={2}>{data?.grupo_territorial || ""}</TableCell>
          <TableCell style={styles.boldText} flex={2}>
            <Text style={styles.boldText}>Municipio</Text>
          </TableCell>
          <TableCell flex={2}>{data?.municipio || ""}</TableCell>

          <TableCell style={styles.boldText} flex={2}>
            <Text style={styles.boldText}>Departamento</Text>
          </TableCell>
          <TableCell flex={2} isLastCell>
            {data?.departamento || ""}
          </TableCell>
        </View>

        {Array.isArray(data.lista_participantes) &&
          data.lista_participantes.length > 1 && (
            <View style={styles.tableRow}>
              <TableCell style={styles.boldText} flex={6}>
                <Text style={styles.boldText}>
                  N° de personas vinculadas al proyecto productivo{" "}
                </Text>
              </TableCell>
              <TableCell flex={1}> {data.lista_participantes.length}</TableCell>
              <TableCell isLastCell flex={3}></TableCell>
            </View>
          )}

        {Array.isArray(data.lista_participantes) &&
          data.lista_participantes.length > 1 && (
            <>
              {/* Título de la sección */}
              <View style={[styles.tableRow, styles.tableRowColored]}>
                <TableCell flex={1} isLastCell>
                  <Text style={[styles.title, styles.centeredText]}>
                    INFORMACIÓN DE LAS PERSONAS VINCULADAS AL PROYECTO
                    PRODUCTIVO INDIVIDUAL ASOCIATIVO
                  </Text>
                </TableCell>
              </View>

              {/* Cabecera de columnas */}
              <View style={[styles.tableRow, styles.tableHeader]}>
                <TableCell flex={1}>
                  <Text style={[styles.text, styles.boldText]}>Nombre</Text>
                </TableCell>
                <TableCell flex={1}>
                  <Text style={[styles.text, styles.boldText]}>
                    Identificación
                  </Text>
                </TableCell>
                <TableCell flex={1} isLastCell>
                  <Text style={[styles.text, styles.boldText]}>
                    Código SIRR
                  </Text>
                </TableCell>
              </View>

              {/* Filas con datos */}
              {data.lista_participantes.map((persona, index) => (
                <View key={index} style={styles.tableRow}>
                  <TableCell flex={1}>
                    <Text style={styles.text}>
                      {persona.nombreTitular || ""}
                    </Text>
                  </TableCell>
                  <TableCell flex={1}>
                    <Text style={styles.text}>
                      {persona.identificacion || ""}
                    </Text>
                  </TableCell>
                  <TableCell flex={1} isLastCell>
                    <Text style={styles.text}>{persona.codigoSIRR || ""}</Text>
                  </TableCell>
                </View>
              ))}
            </>
          )}

        {/* Fila 1: 1 columnas */}
        {Array.isArray(data.lista_bienes) && data.lista_bienes.length > 0 && (
          <>
            <View style={[styles.tableRow, styles.tableRowColored]}>
              <TableCell flex={1} isLastCell>
                <Text style={[styles.title, styles.centeredText]}>
                  RELACIÓN DE BIENES A ENTREGAR AL PROYECTO PRODUCTIVO
                </Text>
              </TableCell>
            </View>

            {/* Cabecera de columnas */}
            <View style={[styles.tableRow, styles.tableHeader]}>
              <TableCell flex={1}>
                <Text style={[styles.text, styles.boldText]}>ITEM</Text>
              </TableCell>
              <TableCell flex={5}>
                <Text style={[styles.text, styles.boldText]}>DESCRIPCIÓN</Text>
              </TableCell>
              <TableCell flex={2}>
                <Text style={[styles.text, styles.boldText]}>UNIDAD</Text>
              </TableCell>
              <TableCell flex={1.5}>
                <Text style={[styles.text, styles.boldText]}>CANTIDAD</Text>
              </TableCell>
              <TableCell flex={3} isLastCell>
                <Text style={[styles.text, styles.boldText]}>
                  OBSERVACIONES
                </Text>
              </TableCell>
            </View>

            {data.lista_bienes.map((bien, index) => (
              <View key={index} style={styles.tableRow}>
                <TableCell flex={1}>
                  <Text style={styles.text}>{bien.item || ""}</Text>
                </TableCell>
                <TableCell flex={5}>
                  <Text style={styles.text}>{bien.descripcion || ""}</Text>
                </TableCell>
                <TableCell flex={2}>
                  <Text style={styles.text}>{bien.unidad || ""}</Text>
                </TableCell>
                <TableCell flex={1.5}>
                  <Text style={[styles.text, styles.centeredText]}>
                    {bien.cantidad || ""}
                  </Text>
                </TableCell>
                <TableCell flex={3} isLastCell>
                  <Text style={styles.text}></Text>
                </TableCell>
              </View>
            ))}

            {/* Fila final con total */}
            <View style={[styles.tableRow, styles.tableRowColored]}>
              <TableCell flex={3}>
                <Text style={[styles.title, styles.centeredText]}>
                  VALOR TOTAL DEL FORTALECIMIENTO AL PROYECTO PRODUCTIVO
                </Text>
              </TableCell>
              <TableCell flex={2} isLastCell>
                <Text style={[styles.text, styles.boldText]}>
                  {Array.isArray(data.lista_participantes)
                    ? `$${(
                        data.lista_participantes.length * 3000000
                      ).toLocaleString("es-CO")}`
                    : "$0"}
                </Text>
              </TableCell>
            </View>
          </>
        )}

        <View style={[styles.tableRow]}>
          <TableCell flex={1} isLastCell>
            <Text style={styles.textoNotas}>
              * Los valores son estimados y están sujetos a las posibles
              variaciones de precios presentadas en el mercado al momento de
              compra a los proveedores.{"\n"}* El valor total incluye el costo
              del flete hasta el sitio de entrega acordado.
            </Text>
          </TableCell>
        </View>

        <View style={[styles.tableRow]}>
          <TableCell flex={1} isLastCell>
            <Text style={[styles.title, styles.centeredText]}>
              SITIO DE ENTREGA
            </Text>
          </TableCell>
        </View>

        <View
          style={[
            styles.tableRow,
            !data?.sitio_entrega && styles.defaultHeightRow,
          ]}
        >
          <TableCell flex={1} isLastCell>
            <Text style={styles.title}>{data?.sitio_entrega || ""}</Text>
          </TableCell>
        </View>

        <View style={[styles.tableRow]}>
          <TableCell style={styles.boldText} flex={1} isLastCell>
            <Text style={styles.boldText}>
              Se valida la anterior información acordada entre el representante
              del proyecto y el profesional de asistencia técnica para la
              construcción del Plan de Compras.
            </Text>
          </TableCell>
        </View>
      </View>

      <View wrap={false} >
        <View style={styles.table}>
          <View style={[styles.tableRow]}>
            <TableCell style={styles.boldText} flex={1} isLastCell>
              <Text style={styles.boldText}>
                Siendo hoy, día {data?.dia || "_____"} mes{" "}
                {data?.mes || "_________________"} de {data?.anio || "_____"}, firman:
              </Text>

            </TableCell>
          </View>
          <View style={[styles.tableRow, styles.tableHeader]}>
            <TableCell flex={1}>
              <Text style={[styles.text, styles.boldText]}>
                PROFESIONAL ASISTENCIA TÉCNICA
              </Text>
            </TableCell>
            <TableCell flex={1} isLastCell>
              <Text style={[styles.text, styles.boldText]}>
                CONFORMIDAD DEL TITULAR DEL PRE-PP {"\n"}
                PROPUESTA SOCIALIZADA A TITULAR DEL PRE-PP
              </Text>
            </TableCell>
          </View>

          {/* Fila: NOMBRE */}
          <View style={[styles.tableRow, styles.tableHeader]}>
            <TableCell flex={1}>
              <Text style={[styles.text, styles.boldText]}>NOMBRE</Text>
            </TableCell>
            <TableCell flex={3}>
              <Text style={styles.text}>{data?.nombre_profesional || ""}</Text>
            </TableCell>
            <TableCell flex={1}>
              <Text style={[styles.text, styles.boldText]}>NOMBRE</Text>
            </TableCell>
            <TableCell flex={3} isLastCell>
              <Text style={styles.text}></Text>
            </TableCell>
          </View>

          {/* Fila: CEDULA */}
          <View style={[styles.tableRow, styles.tableHeader]}>
            <TableCell flex={1}>
              <Text style={[styles.text, styles.boldText]}>CÉDULA</Text>
            </TableCell>
            <TableCell flex={3}>
              <Text style={styles.text}>{data?.cedula_profesional || ""}</Text>
            </TableCell>
            <TableCell flex={1}>
              <Text style={[styles.text, styles.boldText]}>CÉDULA</Text>
            </TableCell>
            <TableCell flex={3} isLastCell>
              <Text style={styles.text}></Text>
            </TableCell>
          </View>

          {/* Fila: FIRMA / HUELLA */}
          <View style={[styles.tableRow, styles.tableHeader, { height: 60 }]}>
            {/* Celda FIRMA */}
            <TableCell flex={1}>
              <View
                style={{
                  flex: 1,
                  justifyContent: "flex-end",
                  height: "100%",
                }}
              >
                <Text style={[styles.text, styles.boldText]}>FIRMA</Text>
              </View>
            </TableCell>

            {/* Celda vacía */}
            <TableCell flex={3}>
              <View style={{ flex: 1 }} />
            </TableCell>

            {/* Celda FECHA */}
            <TableCell flex={3}>
              <View
                style={{
                  flex: 1,
                  justifyContent: "flex-end",
                  height: "100%",
                }}
              >
                <Text style={[styles.text, styles.boldText]}>FIRMA</Text>
              </View>
            </TableCell>

            {/* Celda HUELLA */}
            <TableCell flex={1} isLastCell>
              <View
                style={{
                  flex: 1,
                  justifyContent: "flex-end",
                  height: "100%",
                }}
              >
                <Text style={[styles.text, styles.boldText]}>HUELLA</Text>
              </View>
            </TableCell>
          </View>
        </View>
      </View>


 </View>
      <View style={styles.footerCodeContainer}>
        <Text style={styles.footerCode}>
          Código Único: {data?.codigo_interno || ""}
        </Text>{" "}
      </View>
    </Page>
  </Document>
);

export default PdfDocumentoAceptacion;
